Object.defineProperty(exports, "__esModule", { value: true });
var IDENTIFIER_CLASS_NAME = 'stashable';
var REVERSE_IDENTIFIER_CLASS_NAME = 'reverse-stashable';
var CLASS_NAME_TO_BE_TOGGLED = 'hide';
var STASHABLE_NODES = [];
var REVERSE_STASHABLE_NODES = [];
var hidden;
function init() {
    STASHABLE_NODES = document.getElementsByClassName(IDENTIFIER_CLASS_NAME);
    REVERSE_STASHABLE_NODES = document.getElementsByClassName(REVERSE_IDENTIFIER_CLASS_NAME);
}
function hide() {
    if (hidden !== undefined && hidden)
        return;
    for (var index = 0; index < STASHABLE_NODES.length; index++) {
        if (STASHABLE_NODES[index].className.indexOf(' ' + CLASS_NAME_TO_BE_TOGGLED) < 0) {
            STASHABLE_NODES[index].className += ' ' + CLASS_NAME_TO_BE_TOGGLED;
        }
    }
    for (var index = 0; index < REVERSE_STASHABLE_NODES.length; index++)
        REVERSE_STASHABLE_NODES[index].className = REVERSE_STASHABLE_NODES[index].className.replace(' ' + CLASS_NAME_TO_BE_TOGGLED, '');
    hidden = true;
}
function show() {
    if (hidden !== undefined && !hidden)
        return;
    for (var index = 0; index < REVERSE_STASHABLE_NODES.length; index++) {
        if (REVERSE_STASHABLE_NODES[index].className.indexOf(' ' + CLASS_NAME_TO_BE_TOGGLED) < 0) {
            REVERSE_STASHABLE_NODES[index].className += ' ' + CLASS_NAME_TO_BE_TOGGLED;
        }
    }
    for (var index = 0; index < STASHABLE_NODES.length; index++)
        STASHABLE_NODES[index].className = STASHABLE_NODES[index].className.replace(' ' + CLASS_NAME_TO_BE_TOGGLED, '');
    hidden = false;
}
exports.default = {
    init: init,
    hide: hide,
    show: show
};
